import { Component, Inject, inject, Injectable } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

/**
 * The tour service.
 */
@Injectable()
export class ToastService {

  constructor(private _snackBar: MatSnackBar) {
  }

  addToastWithAction(message: string, actionLabel: string, action: () => void) {
    this._snackBar.openFromComponent(NxToastComponent, {
      duration: 5000,
      data: { 
        message: message,
        actionLabel: actionLabel,
        action: action }
    });
  }

  addToastWithMessage(message: string) {
    this._snackBar.openFromComponent(NxToastComponent, {
      duration: 5000,
      data: { 
        message: message
      }
    });
  }
  
}

@Component({
  selector: 'nx-toast',
  template: `
    <div class="nx-toast flex flex-row justify-between w-full items-center">
      <div class="nx-toast" matSnackBarLabel>
      {{data?.message | translate}}
    </div>
    <div *ngIf="data?.action" matSnackBarActions class="flex flex-row justify-end grow">
      <nx-default-button
        class="nx-toast-action"
        (click)="action()"
        [label]="data?.actionLabel | translate">
      </nx-default-button>
    </div>
  </div>
  `,
  styles: [
    `
    :host {
      display: flex;
    }
  `,
  ]
})
export class NxToastComponent {
  snackBarRef = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}


  action(){
    this.data.action();
    this.snackBarRef.dismiss();
  }
}
